import type { ReactNode } from 'react';
import { cn } from '../cn';

export interface FieldProps {
  label: string;
  htmlFor?: string;
  hint?: ReactNode;
  error?: string | null | undefined;
  required?: boolean;
  className?: string;
  children: ReactNode;
}

export function Field({ label, htmlFor, hint, error, required, className, children }: FieldProps) {
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      <label
        htmlFor={htmlFor}
        className="text-2xs text-ink-600 font-semibold uppercase tracking-wider"
      >
        {label}
        {required && <span className="text-danger-500 ml-1">*</span>}
      </label>
      {children}
      {error ? (
        <p className="text-danger-500 text-xs" role="alert">
          {error}
        </p>
      ) : hint ? (
        <p className="text-ink-500 text-xs">{hint}</p>
      ) : null}
    </div>
  );
}
